import React from 'react'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import styled from 'styled-components'
import { Tooltip } from '@mui/material'

const DeactivateIcon = ({ onClick, title }) => {
  return (
    <Tooltip title={title ? title : 'Dezaktywacja'}>
      <Content>
        <StyledIcon onClick={onClick} />
      </Content>
    </Tooltip>
  )
}

export default DeactivateIcon

const StyledIcon = styled(CancelOutlinedIcon)`
  cursor: pointer;
  font-size: 18px !important;
`

const Content = styled.div`
  display: flex;
  align-items: center;
`
